<script setup lang="ts">
import type { ReadonlyDeep } from 'type-fest';
import type * as openapi from '@/helpers/api/types/openapiOverrides';
import type { ARServiceItem } from '@/models/airRoad';

import _cloneDeep from 'lodash/cloneDeep';

import {
  ARServicesDeliveryList,
  ARServicesPickupList,
} from '@/utils/PortalConstants';
import NewAirRoadSpecialOptionsBasicList from '@/components/basicLists/NewAirRoadSpecialOptionsBasicList.vue';
import StepNewAirRoadHeader from '@/components/headers/StepNewAirRoadHeader.vue';
import * as airRoadConstants from '@/constants/airRoad';

export interface Props {
  airRoadBookingJob?: ReadonlyDeep<openapi.AirroadJobDetailedContentOpenapi>;
}
const props = withDefaults(defineProps<Props>(), {
  airRoadBookingJob: undefined,
});

const model = defineModel<{
  params: openapi.AirroadSingleCreateQueryOpenapi;
  data: openapi.AirroadSingleCreateBodyOpenapi;
  _deliverySpecialOptions: Record<string, ARServiceItem>;
  _pickupSpecialOptions: Record<string, ARServiceItem>;
}>({
  default: () => _cloneDeep(airRoadConstants.defaultBookingState),
});
</script>

<template>
  <section
    :class="$style.specialOptionsStepNewAirRoadSection"
    data-testid="specialOptionsStepNewAirRoadSection"
  >
    <StepNewAirRoadHeader>
      <hgroup>
        <h1>Job #{{ props.airRoadBookingJob?.rockhopper_id }}</h1>
        <h3>Special options</h3>
      </hgroup>
    </StepNewAirRoadHeader>
    <h4>Delivery</h4>
    <NewAirRoadSpecialOptionsBasicList
      v-model="model._deliverySpecialOptions"
      :special-options="ARServicesDeliveryList"
    />
    <h4>Pick up</h4>
    <NewAirRoadSpecialOptionsBasicList
      v-model="model._pickupSpecialOptions"
      :special-options="ARServicesPickupList"
    />
  </section>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.specialOptionsStepNewAirRoadSection {
}
</style>
